import GoogleMapReact from 'google-map-react'
import { useAppState, useAppDispatch } from './Context'
import { useEffect, useRef, useState } from 'react'
import MapMarker from './MapMarker'

const defaultMapCenter = {
  lat: 43.0983671,
  lng: -75.2487004,
}

const mapOptions = {
  maxZoom: 18,
  fullscreenControl: false,
  zoomControlOptions: {
    position: 9, // google.maps.ControlPosition.RIGHT_BOTTOM
  },
}

function Map({ apiKey }) {
  const mapRef = useRef()
  const dispatch = useAppDispatch()
  const [map, setMap] = useState()
  const [maps, setMaps] = useState()
  const { locations, mapVisible, selectedLocation } = useAppState()

  useEffect(() => {
    if (map && selectedLocation) {
      map.panTo(new maps.LatLng(selectedLocation.lat, selectedLocation.lng))
    }
  }, [map, selectedLocation])

  const handleOutsideClick = (e) => {
    if (!e.target.closest('.map-location')) {
      dispatch({ type: 'setSelectedLocation', payload: null })
    }
  }

  const apiIsLoaded = (map, maps) => {
    setMap(map)
    setMaps(maps)

    const bounds = new maps.LatLngBounds()

    locations.forEach((location) => {
      if (!location.excludeFromMapBoundsCenter) {
        bounds.extend(new maps.LatLng(location.lat, location.lng))
      }
    })

    map.setCenter(bounds.getCenter())
    map.fitBounds(bounds)

    maps.event.addListenerOnce(map, 'idle', () => {
      mapRef.current.classList.remove('is-loading')
    })
  }

  return (
    <div
      id="google-map"
      ref={mapRef}
      className={`is-loading locations-map-container ${mapVisible ? 'locations-map-container--visible' : ''}`}
      onClick={handleOutsideClick}
    >
      <div className="w-full">
        <GoogleMapReact
          bootstrapURLKeys={{ key: apiKey }}
          defaultCenter={defaultMapCenter}
          defaultZoom={14}
          options={mapOptions}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)}
        >
          {locations.map((location) => (
            <MapMarker key={location.id} location={location} lat={location.lat} lng={location.lng} />
          ))}
        </GoogleMapReact>
      </div>
    </div>
  )
}

export default Map
